import { Compatibility, SceneObject, debounce } from '@cgs/wge';

export class CorsicaBonusOrientationHandlerComponent {
  private managedElements: SceneObject[] = [];
  private debouncedResize: () => void;

  constructor() {
    this.debouncedResize = debounce(() => this.resize(), 100);
    window.addEventListener('resize', this.debouncedResize);
    window.addEventListener('orientationchange', this.debouncedResize);
  }

  public addManagedElements(elements: SceneObject[]): void {
    this.managedElements.push(...elements);
    this.resize(); // Apply initial state
  }

  public clearManagedElements(): void {
    this.managedElements = [];
  }

  protected resize(): void {
    const state = Compatibility.isPortrait ? 'portrait' : 'landscape';
    if (state === 'portrait') {
      //TODO: ??
    }
    for (const element of this.managedElements) {
      if (element && element.stateMachine) {
        element.stateMachine.switchToState(state);
      }
    }
  }

  public dispose(): void {
    this.clearManagedElements();
    window.removeEventListener('resize', this.debouncedResize);
    window.removeEventListener('orientationchange', this.debouncedResize);
  }
}
